import { defineMessages } from 'react-intl-next';

export const messages: {
    eventLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; joinMeetingLink: {
        defaultMessage: string;
        description: string;
        id: string;
    }; meetingLink: {
        defaultMessage: string;
        description: string;
        id: string;
    }; meetingLinkIcon: {
        defaultMessage: string;
        description: string;
        id: string;
    }; pastEventsButton: {
        defaultMessage: string;
        description: string;
        id: string;
    }; recurringEventIcon: {
        defaultMessage: string;
        description: string;
        id: string;
    }; recurringMetadataLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; upcomingEventsButton: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	eventLabel: {
		id: 'dynamic-cards-search-page.calendar-event-search-result.calendar-label',
		defaultMessage: 'Calendar',
		description: 'Calendar event label shown as part of the metadata below the calendar event title in the search results, for example "Calendar • SpaceX • Updated 2 hours ago"',
	},
	meetingLink: {
		id: 'dynamic-cards-search-page.calendar-event-search-result.meeting-link',
		defaultMessage: 'Meeting link',
		description: 'Calendar event meeting link label',
	},
	joinMeetingLink: {
		id: 'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link',
		defaultMessage: 'Join meeting',
		description: 'Calendar event join upcoming meeting link',
	},
	meetingLinkIcon: {
		id: 'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon',
		defaultMessage: 'Join meeting',
		description: 'Calendar event join upcoming meeting icon',
	},
	recurringEventIcon: {
		id: 'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon',
		defaultMessage: 'Recurring event',
		description: 'Calendar event recurring event icon',
	},
	recurringMetadataLabel: {
		id: 'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label',
		defaultMessage: 'Recurring',
		description: 'Indicates whether the calendar event has recurring events',
	},
	upcomingEventsButton: {
		id: 'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button',
		defaultMessage: 'Upcoming events',
		description: 'Label for the call to action to display the upcoming events',
	},
	pastEventsButton: {
		id: 'dynamic-cards-search-page.calendar-event-search-result.past-events-button',
		defaultMessage: 'Past events',
		description: 'Label for the call to action to display the past events',
	},
});
